import React from 'react';
import ConditionDisplay from '@reverbdotcom/commons/src/components/condition_display';
import PriceDisplay from '@reverbdotcom/commons/src/components/price_display';
import RibbonView from '@reverbdotcom/commons/src/components/ribbon_view';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import { get } from 'lodash';
import { Listing, core_apimessages_Listing_ListingType as ListingType } from '../../schemas/rql';
import { listingItemPagePath } from '@reverbdotcom/commons/src/url_helpers';
import BumpTag from '@reverbdotcom/commons/src/components/bump_tag';
import classNames from 'classnames';

interface IProps {
  listing: Listing;
  removePadding?: boolean;
}

class SingleBumpTile extends React.Component<IProps, null> {
  renderOriginalPrice() {
    const { originalPrice } = this.props.listing.pricing;
    if (!originalPrice) { return null; }

    return (
      <span className="product-feature-card__content__price__original">
        {originalPrice.display}
      </span>
    );
  }

  render() {
    const isAuction = this.props.listing.listingType === ListingType.AUCTION;

    return (
      <div className={classNames('product-feature-card', { 'product-feature-card--remove-padding': this.props.removePadding })}>
        <CoreLink
          to={listingItemPagePath(this.props.listing)}
          entityId={this.props.listing.id}
        >
          <div className="product-feature-card__image">
            <img
              alt="featured-listing"
              src={this.props.listing.images[0].source}
            />
            <RibbonView
              auction={isAuction}
              listingStateDescription={this.props.listing.stateDescription}
              listingStateSlug={this.props.listing.state}
              discountDisplay={get(this.props, 'listing.pricing.ribbon.display')}
            />
          </div>
          <div className="product-feature-card__content">
            <div className="product-feature-card__bump-tag">
              <BumpTag />
            </div>
            <h3 className="product-feature-card__content__title">
              {this.props.listing.title}
            </h3>
            <div className="product-feature-card__content__price">
              {this.renderOriginalPrice()}
              <span className="product-feature-card__content__price__current">
                <PriceDisplay
                  amountCents={this.props.listing.pricing.buyerPrice.amountCents}
                  currency={this.props.listing.pricing.buyerPrice.currency}
                  display={this.props.listing.pricing.buyerPrice.display}
                  auction={isAuction}
                />
              </span>
            </div>
            <div className="product-feature-card__content__condition">
              <ConditionDisplay
                slug={this.props.listing.condition.conditionSlug}
                displayName={this.props.listing.condition.displayName}
              />
            </div>
          </div>
        </CoreLink>
      </div>
    );
  }
}

export default SingleBumpTile;
